import { connectInfiniteHits } from 'react-instantsearch-dom'

import { NavItem } from 'components/NavItem'

import { FolderClosed } from 'almanac-ui/icons/16/FolderClosed'

import Styles from './Hits.module.scss'

const Hits = ({
  hits,
  onClick,
  activeFolderId,
  disabledFolderIds = [],
}: {
  hits: any[]
  onClick: (hit: any) => void
  activeFolderId: string | null | undefined
  disabledFolderIds: string[]
}) => {
  return (
    <div className={Styles.searchResultsContainer}>
      {hits.length === 0 && <p>No folders found</p>}

      {hits.length > 0 &&
        hits.map((hit) => {
          if (disabledFolderIds.includes(hit.key) || hit.uploads_project) return null

          const active = hit.key === activeFolderId

          return (
            <NavItem.Root
              key={hit.key}
              isActive={active}
              onPress={() => {
                onClick(hit)
              }}
              elementType="div"
              noMargin
            >
              <NavItem.Emoji>{hit.header_emoji || <FolderClosed />}</NavItem.Emoji>
              <NavItem.Label label={hit.title} />
            </NavItem.Root>
          )
        })}
    </div>
  )
}

export const CustomHits = connectInfiniteHits(Hits)
